








































import { Component, Prop, Vue } from "vue-property-decorator";
import { mask } from "vue-the-mask";
import PersonNameBD from "_C/main/FormParts/PersonForm/PersonNameBD.vue";
import PersonDriverLicense from "_C/main/FormParts/PersonForm/PersonDriverLicense.vue";
import { InsuranceCard, Driver } from "@/services/index.defs";
@Component({
    directives: { mask },
    components: { PersonDriverLicense, PersonNameBD }
})
export default class DriversHost extends Vue {
    @Prop() drivers: Driver[];

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }

    addDriver() {
        this.drivers.push(new Driver());
    }
    removeDriver(driver: Driver) {
        this.drivers.splice(
            this.drivers.findIndex(x => x == driver),
            1
        );
        //if(this.card.drivers.length == 0)this.driversUnlimited = true;
    }
    clearDriver(driver: Driver) {
        this.drivers.splice(
            this.drivers.findIndex(x => x == driver),
            1,
            new Driver()
        );
    }
}
